(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const init = () => {
    const root = document.querySelector('.brand-home--hybrid');
    const hero = root && root.querySelector('.siecle-hero');
    const logo = root && root.querySelector('[data-siecle-scroll-logo]');
    const header = document.querySelector('#header-component');

    if (!root || !hero || !logo || !header || logo.dataset.scrollLogoReady === 'true') return;
    logo.dataset.scrollLogoReady = 'true';

    const page = document.documentElement;
    let raf = 0;
    let lastProgress = -1;

    const update = () => {
      raf = 0;
      const heroRect = hero.getBoundingClientRect();
      const row = header.querySelector('.header__row--top') || header;
      const rowRect = row.getBoundingClientRect();

      const targetY = Math.max(29, Math.min(42, rowRect.height / 2));
      const startY = Math.max(targetY + 70, window.innerHeight * 0.46);

      // Use the hero's viewport geometry, not window.scrollY. This also works
      // when Shopify's preview or a theme wrapper owns the scroll container.
      const heroCenter = heroRect.top + heroRect.height * 0.46;
      const travel = Math.max(1, startY - targetY);
      const progress = clamp((startY - heroCenter) / travel, 0, 1);
      const eased = progress * progress * (3 - 2 * progress);

      const baseWidth = logo.offsetWidth || Math.min(window.innerWidth * 0.44, 620);
      const targetWidth = window.innerWidth < 750
        ? clamp(window.innerWidth * 0.18, 72, 84)
        : clamp(window.innerWidth * 0.058, 88, 104);
      const scale = 1 + ((targetWidth / baseWidth) - 1) * eased;
      const y = startY + (targetY - startY) * eased;

      logo.style.top = y + 'px';
      logo.style.transform = 'translate3d(-50%,-50%,0) scale(' + scale + ')';
      page.classList.toggle('siecle-home-header-scrolled', progress >= 0.42);
      root.classList.toggle('siecle-home-logo-docked', progress >= 0.995);

      if (progress >= 0.995) {
        logo.style.top = targetY + 'px';
        logo.style.transform = 'translate3d(-50%,-50%,0) scale(' + (targetWidth / baseWidth) + ')';
      }
      lastProgress = progress;
    };

    const schedule = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };

    update();
    // Listen both to the window and to nested scrolling containers.
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);

    // Re-measure after image/fonts settle, but keep the animation geometry stable.
    window.addEventListener('load', schedule, { once: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(hero);
      observer.observe(header);
      observer.observe(logo);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();